import { Theme } from "../../components/constants";

export default {
    headerContainer: {
        display: "flex",
        alignItems: "center",
        columnGap: "60px",
    },

    headerText: {
        display: "flex",
        alignItems: "center",
        columnGap: "10px"
    },

    gridContainer: {
        marginTop: "0px"
    },

    selectDropdown: {
        display: "flex",
        columnGap: "20px",
        alignItems: "end"
    },

    button: {
        padding: "6px 22px",
        margin: "5px"
    },

    buttonBackgroundWIcon: {
        background: "none",
    },

    actionButtons: {
        display: "flex",
        columnGap: "10px",
        alignItems: "center"
    },

    text: {
        fontSize: "14px",
        color: Theme.TEXT_PRIMARY_BLACK
    },

    dropdownContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        padding: "25px 0 25px"
    },

    okButton: {
        padding: "6px 30px",
        marginTop: "30px"
    },

    modalBody: {
        padding: "0px 20px 25px 40px"
    },

    cancelButton: {
        padding: "6px 30px",
        margin: "30px 0px 0px 20px"
    },

    modalBodyWTextArea: {
        marginTop: "25px",
        padding: "1px 20px 25px 40px"
    },

    modalHeaderWTextArea: {
        padding: "30px 20px 0px 40px"
    },

    resubmitBtn: {
        marginLeft: "auto"
    },

    frequencyPopupBody: { 
        display: 'flex', 
        alignItems: 'center', 
        flexDirection: 'column'
    },
    frequencyPopupPaddingTen: { 
        padding: '10px'
    },
    frequencyPopupFooter: {
        display: 'flex', 
        flexDirection: 'row', 
        padding: '20px', 
        gap: '10px'
    },
    buttonContainer:{
        display: "flex",
        justifyContent: "flex-end"
    },
    moreActionDropdown: {
        background: "#F8FAFB",
        border: "1px solid #215DAA",
        borderRadius: "80px",
        padding: "6px 22px",
        height: "fit-content",
        margin: "5px"
    },
    moreActionDropdownLabel: {
        marginRight: "16px",
        fontSize: "16px",
        color: `${Theme.TEXT_PRIMARY}`
    },
    moreActionDropdownMenu: {
        width: "max-content",
        minWidth: "auto",
        left: "-125px",
        top: "29px",
    },
    

}